import FadeInWrapper from "../../../components/common/fade-in-wrapper";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useEffect } from "react";
import RibonIcon from "./image/ribon.png";
import ChefIcon from "./image/chef.png";
import StoreIcon from "./image/store.png";
import PersonIcon from "./image/person.png";
import CookIcon from "./image/cook.png";

// Preload Images for Next Page
import PercentIcon from "../notification/info/images/percent_icon3.png";
import GraphIcon from "../notification/info/images/graph_icon2.png";
import SneakersIcon from "../notification/info/images/sneakers_icon2.png";

const OnboardingFriends = () => {
  const navigate = useNavigate();

  // Preload Images for Next Page
  useEffect(() => {
    const imagesToPreload = [PercentIcon, GraphIcon, SneakersIcon];

    imagesToPreload.forEach((imageSrc) => {
      const img = new Image();
      img.src = imageSrc;
    });
  }, []);

  const friends = [
    {
      image: RibonIcon,
      title: "블루리본",
    },
    {
      image: StoreIcon,
      title: "소상공인",
    },
    {
      image: ChefIcon,
      title: "흑백요리사",
    },
    {
      image: CookIcon,
      title: "유학파 출신",
    },
    {
      image: PersonIcon,
      title: "수십만 유저",
    },
  ];

  return (
    <div className="h-full bg-white min-h-screen relative pb-44 flex flex-col justify-center">
      <div className="mt-4">
        <FadeInWrapper className="flex flex-col h-full pt-4 px-4 mb-8">
          {/* 타이틀 */}
          <div className="flex items-start mb-4">
            <div
              className="w-2 h-full bg-blue-500 rounded-lg mr-4"
              style={{ minHeight: "85px" }}
            />
            <h1 className="text-4xl text-black font-[900] leading-snug">
              이렇게 멋진 <br />
              사장님들이 함께해요
            </h1>
          </div>
        </FadeInWrapper>

        <FadeInWrapper className="grid grid-cols-6 gap-3 px-4">
          {friends.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1, duration: 0.4 }}
              className={`${
                index < 2 ? "col-span-3" : "col-span-2"
              } bg-white rounded-[20px] p-2 py-4 flex flex-col items-center justify-center shadow-sm border border-gray-100 aspect-[3/4]`}
            >
              {/* Icon */}
              <div
                className={`${
                  index < 2 ? "w-20 h-20" : "w-14 h-14"
                } flex items-center justify-center mb-2`}
              >
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-contain drop-shadow-sm"
                />
              </div>

              {/* Title */}
              <h3
                className={`${
                  index < 2 ? "text-[15px]" : "text-[11px]"
                } font-bold text-gray-900 text-center leading-tight break-keep whitespace-pre-line`}
              >
                {item.title}
              </h3>
            </motion.div>
          ))}
        </FadeInWrapper>

        <FadeInWrapper className="mt-8 text-center text-gray-500 text-sm">
          이외에도 다양한 히어로들이 있어요
        </FadeInWrapper>
      </div>

      {/* 버튼 영역 */}
      <FadeInWrapper className="px-5 py-4 w-full fixed bottom-0 left-0 bg-white">
        <Button
          onClick={() => navigate("/onboarding/notification/info")}
          text="다음"
        />
      </FadeInWrapper>
    </div>
  );
};

export default OnboardingFriends;

const Button = ({ onClick, text }: { onClick: () => void; text: string }) => {
  return (
    <div className="inline w-full">
      <button
        onClick={onClick}
        className={`w-full h-[60px] flex items-center justify-center rounded-3xl font-bold bg-[#1562fc] text-white text-lg shadow-lg hover:bg-blue-600 transition-colors`}
      >
        {text}
      </button>
    </div>
  );
};
